enum ClientModalWindowTitle {
  ClientAddFormTitle = 'Add Client'
}

export default ClientModalWindowTitle;
